<td-wb-empty class="td-wb-application-error">
  <td-wb-icon class="td-wb-application-error__icon"
              tdWbEmptyIcon
              iconId="circle-error"
              size="60" />
  <td-wb-empty-header class="td-wb-application-error__title"
                      [translate]="header()" />
  <td-wb-empty-sub-header id="td-wb-application-error-description">
    <div [translate]="title()"></div>
    <div [translate]="subTitle()"></div>
  </td-wb-empty-sub-header>
</td-wb-empty>
